import { ReactToExerciseEventType, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level3.json";

const Level3: Tutorial = {
  end: '2:46',
  level: 3,
  videoUrl: 'level-3.mp4',
  sections: [
    {
      chapters: [
        {
          title: 'B in the Bass Clef',
          start: '0:0',
          data: [ChapterType.Lecture],
        },
        {
          title: 'B on the Keyboard',
          start: '0:25',
          data: [ChapterType.Lecture],
        },
        {
          title: 'Find B',
          start: '0:39',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  transition: 'Dissolve',
                  textPromptPosition: 'Top',
                  objectives: [
                    {
                      text: 'Play B on your keyboard.',
                      target: 'B3',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          title: 'Playing with the 2nd Finger',
          start: '0:46',
          data: [ChapterType.Lecture],
        },
        {
          title: 'Playing B',
          start: '0:56',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: false,
                  padding_x: 650,
                  objectives: [
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
        {
          title: 'Alternating Fingers',
          start: '1:09',
          data: [ChapterType.Lecture],
        },
        {
          title: 'Playing B and C',
          start: '1:29.5',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: true,
                  objectives: [
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
        {
          title: 'Playing in Time',
          start: '1:41',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
        {
          title: 'Using Both Hands',
          start: '1:55',
          data: [ChapterType.Lecture],
        },
        {
          title: 'Switching Hands',
          start: '2:30.5',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
      ],
    },
  ],
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level3);
